// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-72233bcd]:export {\n  menuBg: #E25527;\n  menuText: #ffffff;\n  menuActiveText: #E25527;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n.pagination-container[data-v-72233bcd] {\n  background: #fff;\n  padding: 32px 16px;\n}\n.pagination-container.hidden[data-v-72233bcd] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
